import React from 'react'

import { colors } from '~tokens/internal'

interface CallIncomingIconProps {
  width?: number
  height?: number
  alt?: string
  fill?: string
}

const CallIncomingIcon: React.FC<CallIncomingIconProps> = ({
  width = 24,
  height = 24,
  alt = 'Call incoming icon',
  fill = colors.purple[50],
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      aria-label={alt}
    >
      <title>{alt}</title>
      <path
        d='M19.23 15.2598L16.69 14.9698C16.08 14.8998 15.48 15.1098 15.05 15.5398L13.21 17.3798C10.38 15.9398 8.06004 13.6298 6.62004 10.7898L8.47004 8.93976C8.90004 8.50977 9.11004 7.90977 9.04004 7.29977L8.75004 4.77977C8.63004 3.76977 7.78004 3.00977 6.76004 3.00977H5.03004C3.90004 3.00977 2.96004 3.94977 3.03004 5.07977C3.56004 13.6198 10.39 20.4398 18.92 20.9698C20.05 21.0398 20.99 20.0998 20.99 18.9698V17.2398C21 16.2298 20.24 15.3798 19.23 15.2598Z'
        fill={fill}
      />
      <path
        d='M18.5938 5.07324L17.2383 6.29883H20.7744V7.83105H17.2383L18.5723 9.05664L17.3867 10.1299L14 7.06543L17.3867 4L18.5938 5.07324Z'
        fill={fill}
      />
    </svg>
  )
}

export default CallIncomingIcon
